import React from 'react';

import { Loading } from '@/design-system/atoms/Loading';
import { Text } from '@/design-system/atoms/Text';

import { useDirectoryContext } from '../../context/DirectoryContext';
import styles from '../../Directory.module.scss';
import { LocationList } from '../LocationList';

const DirectorySearchResults = ({ analytics, results, ...props }) => {
    const {
        coveo: {
            controller: { querySummary },
        },
        resultListState,
        noResultsComponent,
        errorComponent,
    } = useDirectoryContext();

    const [querySummaryState, setQuerySummaryState] = React.useState(querySummary.state);

    const noResultsComponentWithAnalytics = React.useMemo(() => {
        if (!React.isValidElement(noResultsComponent)) {
            return;
        }

        return React.cloneElement(noResultsComponent, {
            analytics: {
                ...analytics,
                interactionType: 'internal_link',
                searchTerm: querySummaryState.query,
            },
        });
    }, [noResultsComponent, analytics, querySummaryState]);

    React.useEffect(() => {
        return querySummary.subscribe(() => {
            setQuerySummaryState(querySummary.state);
        });
    }, [querySummary]);

    const state = [
        { state: 'error', valid: resultListState.hasError },
        { state: 'loading', valid: resultListState.isLoading },
        { state: 'noResults', valid: results.length === 0 },
        { state: 'showResults', valid: results.length > 0 },
    ].find(({ valid }) => valid)?.state;

    if (!state) {
        return null;
    }
    return (
        <div className={styles['directory__search-results']}>
            {state === 'error' && <>{errorComponent}</>}
            {state === 'loading' && (
                <div className={styles['directory__search-overlay']}>
                    <Loading />
                </div>
            )}
            {state === 'noResults' && <>{noResultsComponentWithAnalytics}</>}
            {state === 'showResults' && (
                <>
                    <div className={styles[`directory__search-summary`]}>
                        <Text
                            variant={Text.VARIANT.T2}
                            tag={Text.TAG.P}
                            content={`Showing ${results.length} results`}
                        />
                    </div>
                    <LocationList
                        listItems={results}
                        analytics={{ ...analytics, searchTerm: querySummaryState.query }}
                    />
                </>
            )}
        </div>
    );
};

DirectorySearchResults.propTypes = {};

export default DirectorySearchResults;
